export const NON_BR_SPACE = String.fromCharCode(160);
